import { goToMessenger } from "../libs/services";
import { ChannelDeleteResponse } from "../proto/ChannelDelete_pb";
import { ChatDeleteResponse } from "../proto/ChatDelete_pb";
import { GroupDeleteResponse } from "../proto/GroupDelete_pb";
import store from "../store";
import { removeRoomMessages } from "../store/messages/actions";
import { removeRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomDeleteResponse extends BaseHandler<ChatDeleteResponse | GroupDeleteResponse | ChannelDeleteResponse> {
  handle() {
    const roomDeleteStatusResponse = this.response.toObject();
    if (roomDeleteStatusResponse.roomId === store.getState().rooms.currentRoom) {
      goToMessenger();
    }
    store.dispatch(removeRoom(roomDeleteStatusResponse.roomId));
    store.dispatch(
      removeRoomMessages({
        roomId: roomDeleteStatusResponse.roomId,
      })
    );
  }
}
